<template>
  <v-card>
    <v-row style="width: 100%" class="pa-0 ma-0">
      <v-col class="welcome__left" cols="6" md="12" style="min-height: 40vh">
        <v-row fill-height align-center>
          <v-col class="text-center">
            <svg viewBox="34.689 50.34 415.462 79.108" width="415.462" height="79.108" class="mr-4">
              <title>WFSafe</title>
              <g id="Group_1060" data-name="Group 1060" transform="matrix(2.336734, 0, 0, 2.336734, -773.820374, -596.926147)" style="">
                <g id="Group_99" data-name="Group 99" transform="translate(346 277)">
                  <g id="Wildfire-SAFE-Logo" transform="translate(0 0)">
                    <g id="Group_1" data-name="Group 1" transform="translate(0 0)">
                      <path
                        id="Path_1"
                        data-name="Path 1"
                        d="M46.46,99.548a14.187,14.187,0,0,1-1.383-1.653A15.237,15.237,0,0,1,44,96.169h0l-.23-.431c-.051-.1-.1-.192-.154-.312-.026-.024-.026-.072-.051-.1-.077-.144-.128-.311-.2-.455-.026-.072-.077-.168-.1-.24-.051-.144-.1-.288-.154-.407a1.713,1.713,0,0,1-.128-.383,14.94,14.94,0,0,1-.768-4.673c0-8.435,7.12-15.312,16.032-15.648-.23,0-.461-.024-.691-.024C48.3,73.5,40.8,80.521,40.8,89.172a14.132,14.132,0,0,0,.768,4.673c.051.12.077.24.128.383s.1.288.154.407c.026.072.077.168.1.24.077.144.128.312.2.455.026.024.026.072.051.1.051.1.1.192.154.312l.23.431h0a20.037,20.037,0,0,0,1.076,1.725,14.185,14.185,0,0,0,1.383,1.653,17.2,17.2,0,0,0,12.523,5.272,6.665,6.665,0,0,0,.691-.024A17.249,17.249,0,0,1,46.46,99.548Z"
                        transform="translate(-40.8 -73.5)"
                        fill="#3e3e3e" />
                      <path
                        id="Path_2"
                        data-name="Path 2"
                        d="M89.472,100.587a17.5,17.5,0,0,1-.307,2.323,16.284,16.284,0,0,1-.615,2.18h0a4.154,4.154,0,0,1-.2.5,2.782,2.782,0,0,0-.128.335c-.026.048-.026.072-.051.12l-.23.5c-.051.1-.077.168-.128.263-.077.144-.154.311-.23.455s-.128.263-.2.407a17.915,17.915,0,0,1-3.355,4.264,19.685,19.685,0,0,1-25.917.5c.179.168.359.359.538.527a19.629,19.629,0,0,0,26.481,0,17.916,17.916,0,0,0,3.355-4.264,2.064,2.064,0,0,0,.2-.407c.077-.144.154-.287.23-.455.051-.1.077-.168.128-.263l.231-.5c.026-.048.026-.072.051-.12a1.8,1.8,0,0,0,.128-.335c.077-.168.128-.335.2-.5h0a16.286,16.286,0,0,0,.615-2.18,18.047,18.047,0,0,0,.307-2.323A16.8,16.8,0,0,0,85.119,88.2c-.179-.168-.384-.335-.563-.5A16.828,16.828,0,0,1,89.472,100.587Z"
                        transform="translate(-53.669 -84.249)"
                        fill="#3e3e3e" />
                      <path
                        id="Path_3"
                        data-name="Path 3"
                        d="M58.16,106.67A8.768,8.768,0,0,1,56.393,95.1c.589-.948,1.306-1.774,1.972-2.674,2.3-2.8,2.561-3.427,2.663-6.927,1.844,1.944,1.972,4.2,1.946,6.538C66.458,89.316,65.92,83.8,61.848,79.4A15.157,15.157,0,0,0,50.4,93.813a14.89,14.89,0,0,0,8.067,13.076A.964.964,0,0,1,58.16,106.67Z"
                        transform="translate(-47.941 -77.966)"
                        fill="#3e3e3e" />
                      <path
                        id="Path_4"
                        data-name="Path 4"
                        d="M103.445,77.1a16.779,16.779,0,0,0-2.945.267c6.1,1.677,13.855,11.132,10.679,19.882,2.484-1.458,2.92-3.865,3.048-6.708a10.329,10.329,0,0,1,1.588,8.337,12.971,12.971,0,0,1-2.407,4.91,14.743,14.743,0,0,0,5.865-11.666C119.272,83.808,112.178,77.1,103.445,77.1Z"
                        transform="translate(-85.211 -76.225)"
                        fill="#3e3e3e" />
                      <path
                        id="Path_5"
                        data-name="Path 5"
                        d="M101.18,157.187a11.966,11.966,0,0,0-1-1.312,4.3,4.3,0,0,1-1.306-3.427,4.249,4.249,0,0,0-.948,3.208c-1.793-1.41-1.409-4.3.82-6.562-3.048-.122-7.939,5.128-6.223,9.941-1.229-.681-1.485-1.871-1.511-3.281a4.9,4.9,0,0,0-.768,4.132,3.509,3.509,0,0,0,.282.875,16.583,16.583,0,0,0,4.687.826c-2.484-5.444-.256-8.361-.256-8.361-1.537,2.625.41,6.587,1.434,8.337a16.709,16.709,0,0,0,5.429-1.142A4.553,4.553,0,0,0,101.18,157.187Z"
                        transform="translate(-77.465 -131.166)"
                        fill="#3e3e3e" />
                    </g>
                  </g>
                  <g id="Group_2" data-name="Group 2" transform="translate(47.351 10.48)">
                    <path
                      id="Path_6"
                      data-name="Path 6"
                      d="M221.493,137.938l2.672-9.338h1.782l-3.523,11.8h-1.782l-3.239-9.568-3.2,9.568h-1.7l-3.6-11.8h1.782l2.753,9.222,3.118-9.222h1.822Z"
                      transform="translate(-208.9 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_7"
                      data-name="Path 7"
                      d="M259.441,140.4H257.7V128.6h1.741Z"
                      transform="translate(-238.126 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_8"
                      data-name="Path 8"
                      d="M279.572,140.4H272V128.6h1.7v10.26h5.871Z"
                      transform="translate(-246.749 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_9"
                      data-name="Path 9"
                      d="M302.133,140.4H297.8V128.6h4.332a6.042,6.042,0,0,1,4.211,1.575,5.609,5.609,0,0,1,1.7,4.342,5.523,5.523,0,0,1-1.7,4.3A5.874,5.874,0,0,1,302.133,140.4Zm-2.591-1.422h2.551a4.074,4.074,0,0,0,4.252-4.419,4.5,4.5,0,0,0-1.174-3.3,4.077,4.077,0,0,0-3-1.153h-2.591v8.877Z"
                      transform="translate(-262.264 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_10"
                      data-name="Path 10"
                      d="M332.9,140.4h-1.7V128.6h7.572v1.5h-5.831v3.8h5.3v1.537h-5.3V140.4Z"
                      transform="translate(-282.304 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_11"
                      data-name="Path 11"
                      d="M358.941,140.4H357.2V128.6h1.741Z"
                      transform="translate(-297.868 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_12"
                      data-name="Path 12"
                      d="M377.938,140.4l-2.834-4.842h-1.863V140.4H371.5V128.6h4.7a3.868,3.868,0,0,1,2.753,1A3.33,3.33,0,0,1,380,132.1a3.276,3.276,0,0,1-.81,2.19,3.517,3.517,0,0,1-2.227,1.153l2.956,4.957Zm-4.7-6.264h2.632a2.7,2.7,0,0,0,1.7-.538,1.743,1.743,0,0,0,.648-1.46,1.869,1.869,0,0,0-.648-1.5,2.51,2.51,0,0,0-1.7-.576h-2.632Z"
                      transform="translate(-306.516 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_13"
                      data-name="Path 13"
                      d="M407.972,140.4H400.4V128.6h7.572v1.5h-5.83v3.612h5.3v1.537h-5.3v3.612h5.83Z"
                      transform="translate(-323.864 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_14"
                      data-name="Path 14"
                      d="M434.475,131.151,432,131.8a1.6,1.6,0,0,0-.567-1,2.089,2.089,0,0,0-1.5-.461,1.826,1.826,0,0,0-1.215.384,1.061,1.061,0,0,0-.486.884c0,.615.4,1,1.215,1.114l1.66.307a4.767,4.767,0,0,1,2.672,1.268,3.273,3.273,0,0,1,.931,2.267,3.391,3.391,0,0,1-1.255,2.613A4.94,4.94,0,0,1,430.1,140.3a5.251,5.251,0,0,1-3.644-1.153A4.216,4.216,0,0,1,425,136.531l2.551-.576a2.066,2.066,0,0,0,.729,1.46,2.737,2.737,0,0,0,1.862.576,2.22,2.22,0,0,0,1.3-.346,1.061,1.061,0,0,0,.486-.884,1,1,0,0,0-.364-.769,1.853,1.853,0,0,0-.972-.423l-1.7-.307a4.254,4.254,0,0,1-2.47-1.23,3.078,3.078,0,0,1-.891-2.229,3.49,3.49,0,0,1,1.3-2.728A4.738,4.738,0,0,1,429.98,128a6.476,6.476,0,0,1,1.984.307,3.8,3.8,0,0,1,1.377.769,4.669,4.669,0,0,1,.81,1A8.444,8.444,0,0,1,434.475,131.151Z"
                      transform="translate(-338.662 -128)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_15"
                      data-name="Path 15"
                      d="M461.515,140.4l-.891-2.382h-4.818l-.891,2.382H452l4.7-11.8h3.2l4.616,11.8Zm-3.239-8.838-1.539,4.073h3Z"
                      transform="translate(-355.207 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_16"
                      data-name="Path 16"
                      d="M491.694,140.4H488.9V128.6h8.017v2.5h-5.223v2.5h4.616v2.382h-4.575V140.4Z"
                      transform="translate(-377.166 -128.369)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_17"
                      data-name="Path 17"
                      d="M523.5,140.4h-7.9V128.6h7.855v2.5h-5.1v2.229h4.616v2.306h-4.616V137.9h5.1v2.5Z"
                      transform="translate(-393.055 -128.369)"
                      fill="#3e3e3e" />
                  </g>
                </g>
              </g>
            </svg>
            <div class="mb-4">
              <img src="/usfs_col_golden.png" width="100" />
            </div>
            <h1>
              {{ $t('views.splash.left.title') }}
            </h1>
            <h4 class="mb-8">
              {{ $t('views.splash.left.subtitle') }}
            </h4>
            <p class="mt-4 partnership-text">
              {{ $t('views.splash.left.partnership') }}
            </p>
            <svg viewBox="181.145 87.15 299.872 55.481" width="299.872" height="55.481">
              <title>Technosylva</title>
              <g id="Group_1061" data-name="Group 1061" transform="matrix(1.651566, 0, 0, 1.651566, -765.936035, -370.33429)" style="">
                <g id="technosylva-logo-white" transform="translate(573.444 277)">
                  <g id="Group_97" data-name="Group 97" transform="translate(57.854 7.052)">
                    <path
                      id="Path_758"
                      data-name="Path 758"
                      d="M344.427,75.6v2.894h2.393V80.82h-2.393v3.663c0,1.191.292,1.758,1.342,1.758.447,0,.759-.073.973-.073v2.4a7.746,7.746,0,0,1-2.179.275A3.722,3.722,0,0,1,342.015,88a4.287,4.287,0,0,1-.895-3.041V80.8H339.7V78.494h1.42V76.3Z"
                      transform="translate(-339.7 -73.896)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_759"
                      data-name="Path 759"
                      d="M389.452,96.638c.078,1.337,1.5,1.978,3.074,1.978a10.05,10.05,0,0,0,3-.421l.447,2.125a11.258,11.258,0,0,1-3.891.641c-3.677,0-5.778-1.978-5.778-5.22a5.238,5.238,0,0,1,5.466-5.44c3.521,0,4.863,2.546,4.863,5.074,0,.568-.078,1.062-.078,1.264Zm3.968-2.125a1.868,1.868,0,0,0-1.868-2.051,2.13,2.13,0,0,0-2.1,2.051Z"
                      transform="translate(-377.235 -85.904)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_760"
                      data-name="Path 760"
                      d="M457.873,100.766a8,8,0,0,1-3,.495c-3.521,0-5.778-1.978-5.778-5.22,0-2.967,2.179-5.44,6.225-5.44a7.309,7.309,0,0,1,2.548.421l-.525,2.326a5.2,5.2,0,0,0-1.868-.275,2.9,2.9,0,1,0,.078,5.788,7.617,7.617,0,0,0,1.945-.275Z"
                      transform="translate(-427.818 -86.149)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_761"
                      data-name="Path 761"
                      d="M506.9,66.3h3.365v5.861h.078a4.991,4.991,0,0,1,1.342-1.062,3.762,3.762,0,0,1,1.732-.421c2.179,0,3.813,1.41,3.813,4.451v5.99h-3.365V75.477c0-1.337-.525-2.253-1.731-2.253a1.741,1.741,0,0,0-1.654,1.136,2.241,2.241,0,0,0-.078.714v6.063h-3.365V66.3Z"
                      transform="translate(-474.374 -66.3)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_762"
                      data-name="Path 762"
                      d="M576.278,94.062c0-1.264-.078-2.326-.078-3.242h2.918l.156,1.41h.078a4.1,4.1,0,0,1,3.365-1.63c2.256,0,3.891,1.41,3.891,4.378v6.063h-3.366V95.4c0-1.337-.525-2.18-1.731-2.18a1.923,1.923,0,0,0-1.731,1.191,2.372,2.372,0,0,0-.156.769v5.861h-3.365l.019-6.979Z"
                      transform="translate(-530.193 -86.149)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_763"
                      data-name="Path 763"
                      d="M654.922,95.094c0,3.737-2.84,5.44-5.7,5.44-3.152,0-5.622-1.978-5.622-5.294s2.315-5.44,5.778-5.44C652.666,89.873,654.922,92.071,654.922,95.094Zm-7.859.147c0,1.758.759,3.1,2.257,3.1,1.264,0,2.179-1.191,2.179-3.1,0-1.557-.6-3.1-2.179-3.1C647.647,92.145,647.063,93.756,647.063,95.24Z"
                      transform="translate(-584.481 -85.495)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_764"
                      data-name="Path 764"
                      d="M713.2,97.975a6.774,6.774,0,0,0,2.918.769c1.05,0,1.42-.348,1.42-.843s-.292-.769-1.576-1.191c-2.257-.714-3.074-1.832-3.074-3.1,0-1.9,1.732-3.315,4.416-3.315a8.208,8.208,0,0,1,3.074.568l-.6,2.18a5.357,5.357,0,0,0-2.315-.568c-.817,0-1.265.275-1.265.843,0,.495.447.714,1.731,1.191,2.1.641,2.918,1.63,2.918,3.169,0,1.9-1.576,3.315-4.727,3.315a7.831,7.831,0,0,1-3.521-.714Z"
                      transform="translate(-640.059 -85.904)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_765"
                      data-name="Path 765"
                      d="M766.057,91.8l1.654,5.019c.156.641.37,1.337.525,1.9h.078a17.351,17.351,0,0,1,.525-1.9l1.342-5.019h3.6l-2.548,6.7c-1.576,4.03-2.626,5.715-3.813,6.7a6.563,6.563,0,0,1-3.288,1.41l-.681-2.674a4.815,4.815,0,0,0,1.5-.568,4.548,4.548,0,0,0,1.42-1.264.946.946,0,0,0,.156-.495.818.818,0,0,0-.156-.495L762.4,91.818C762.38,91.8,766.057,91.8,766.057,91.8Z"
                      transform="translate(-680.17 -87.129)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_766"
                      data-name="Path 766"
                      d="M830.9,66.3h3.365V81.118H830.9Z"
                      transform="translate(-735.345 -66.3)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_767"
                      data-name="Path 767"
                      d="M863.057,91.8l1.5,4.726a18.158,18.158,0,0,1,.6,2.473h.078c.156-.843.37-1.63.6-2.473l1.42-4.726h3.521l-4.047,10.239h-3.365L859.4,91.8Z"
                      transform="translate(-758.301 -87.129)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_768"
                      data-name="Path 768"
                      d="M931.306,100.559l-.234-1.062h-.078a3.83,3.83,0,0,1-3.074,1.264,3.246,3.246,0,0,1-3.521-3.1c0-2.674,2.549-3.956,6.361-3.883v-.147c0-.568-.292-1.337-1.945-1.337a6.384,6.384,0,0,0-3,.769l-.6-2.052a9.09,9.09,0,0,1,4.2-.916c3.6,0,4.8,1.978,4.8,4.378v3.535a19.4,19.4,0,0,0,.155,2.473h-3.073Zm-.37-4.8c-1.79,0-3.151.348-3.151,1.63,0,.843.6,1.191,1.342,1.191a1.8,1.8,0,0,0,1.731-1.191,1.265,1.265,0,0,0,.078-.568Z"
                      transform="translate(-810.656 -85.741)"
                      fill="#3e3e3e" />
                  </g>
                  <g id="Group_98" data-name="Group 98" transform="translate(0 0)">
                    <path
                      id="Path_769"
                      data-name="Path 769"
                      d="M91.863,90.778c1.5,0,5.389-.495,9.59-.916a129.428,129.428,0,0,0,13.189-1.9c4.28-.843-1.654-10.441-13.189-7.968-.37.147-.895.22-1.264.348C87.973,83.855,87,92.683,87,92.683l14.454.916-.156-1.63C101.318,91.969,88.868,90.925,91.863,90.778Z"
                      transform="translate(-78.304 -70.099)"
                      fill="#3e3e3e" />
                    <path
                      id="Path_770"
                      data-name="Path 770"
                      d="M42.3,27.8V61.393H92.587V27.8Zm5.1,26.322c0-9.745,7.859-17.987,18.053-19.123a15.789,15.789,0,0,1,2.626-.147A20.688,20.688,0,0,1,87.412,47.271L70.1,49.6l-.233,1.978,18.811,1.191a3.2,3.2,0,0,1,.156,1.264Z"
                      transform="translate(-42.3 -27.8)"
                      fill="#3e3e3e" />
                  </g>
                </g>
              </g>
            </svg>
          </v-col>
        </v-row>
      </v-col>
      <v-col class="welcome__right pa-4" cols="6" md="12">
        <div class="subheading">
          {{ $t('views.splash.right.subtitle') }}
        </div>
        <div class="heading">
          {{ $t('views.splash.right.title') }}
        </div>
        <p class="body-2">
          {{ $t('views.splash.right.p1') }}
        </p>
        <div class="text-right mt-1">
          <v-checkbox v-model="doNotShow" :label="$t('views.splash.dontShowAgain')" />
        </div>
        <div class="text-right mt-1">
          <v-btn color="primary" @click="closeDialog">
            {{ $t('common.actions.getStarted') }}
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-card>
</template>

<script setup lang="ts">
import { ref } from 'vue'

const doNotShow = ref(false)
const emit = defineEmits<{
  (e: 'close', v: void): void
}>()

const closeDialog = () => {
  if (doNotShow.value) window.localStorage.setItem('DNSWelcomeDialog', 'true')
  emit('close')
}
</script>

<style lang="scss" scoped>
.welcome {
  &__left {
    background-image: url('../assets/welcome-bg.jpg');
    background-size: cover;
    h1 {
      font-size: 32px;
      margin-bottom: 10px;
      font-weight: 400;
    }
    h4 {
      font-size: 12px;
      color: white;
    }
    svg {
      width: 350px;
    }
    .partnership-text {
      font-size: 0.7rem;
      margin-bottom: -0.4rem;
      color: #3e3e3e;
      padding-left: 1.1rem;
    }
  }
  &__right {
    .subheading {
      font-weight: bold;
      font-size: 16px;
      margin-bottom: 10px;
    }
    .heading {
      font-size: 24px;
      font-weight: bold;
      color: #58bdec;
      margin-bottom: 8px;
    }
    .body-2 {
      color: #848484;
    }
    p.small {
      color: #848484;
      font-size: 8px;
    }
  }
}
</style>
